import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApplicationHistory } from '@shared/models';
import { ApiService } from '@shared/services';

@Injectable({ providedIn: 'root' })
export class ApplicationHistoryApiService extends ApiService<ApplicationHistory[]> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'notes/application-history/';
  }
}
